"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { toolbarTableFormSetRowKey, toolbarTableFormSetTableElem } from 'Actions/Table/TableToolBarActions';
import { d5TableUpdateFormUUID } from 'Actions/Table/D5TableActions';
import D5TableStoreClass from "Stores/Table/D5TableStore";
import classNames from 'classnames';
import { Messages } from "Messages";
import Columns from "Stores/Table/core/table/Columns";
import { createTableID } from "D5Utils/functions";

var styles = function styles(theme) {
  return {
    gridContainer: {
      height: 'calc(100% - 66px)'
    },
    fullHeight: {
      height: '100%'
    }
  };
};

var D5Table =
/*#__PURE__*/
function (_React$Component) {
  _inherits(D5Table, _React$Component);

  function D5Table(props) {
    var _this;

    _classCallCheck(this, D5Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(D5Table).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "tableStore", {});

    _this.saveTableStateToLS = _this.saveTableStateToLS.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(D5Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.formID = this.props.formID;
      this.formUUID = this.props.formUUID;
      this.parentFormID = this.props.parentFormID;
      this.popupInst = this.props.popupInst;
      this.instanceForm = this.props.instanceForm;
      this.filtersData = this.props.filtersData;
      this.$tableInstance = $(this.el).dxDataGrid({
        loadPanel: {
          enabled: false,
          showPane: false,
          text: Messages.Controls.LoadingPanel
        },
        noDataText: '',
        columnChooser: {
          enabled: true
        }
      });
      this.tableStore = new D5TableStoreClass({
        instance: this.$tableInstance,
        formUUID: this.formUUID,
        parentUUID: this.props.parentUUID,
        parentFormID: this.parentFormID,
        formID: this.formID,
        filtersData: this.filtersData,
        popupInst: this.popupInst,
        instanceForm: this.instanceForm,
        viewSource: this.props.viewSource,
        requestColumns: this.props.requestColumns,
        tableData: this.props.tableData,
        relationType: this.props.relationType,
        masterObjKeyFieldName: this.props.masterObjKeyFieldName,
        detailObjKeyFieldName: this.props.detailObjKeyFieldName,
        owner: this.props.owner,
        formFilters: this.props.formFilters,
        dataContextMenu: this.props.dataContextMenu
      });
      setTimeout(function () {
        toolbarTableFormSetTableElem(_this2.$tableInstance, _this2.formUUID);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.tableStore.unregister();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      //обновляем formUUID в коммпоненте, кроме подченненыъ таблиц
      if (!this.props.formTableMode && this.formUUID !== nextProps.formUUID) {
        setTimeout(function () {
          d5TableUpdateFormUUID(_this3.props.formUUID, nextProps.formUUID);
        });
        this.formUUID = nextProps.formUUID;
      }

      var configurator = this.tableStore.configurator;

      if (configurator && configurator.isNestedObject() && JSON.stringify(nextProps.tableData) !== JSON.stringify(this.props.tableData)) {
        configurator.prepareNestedData(nextProps.tableData).then(function (data) {
          configurator.instance().option('dataSource', data);
        });
      }
    }
  }, {
    key: "saveTableStateToLS",
    value: function saveTableStateToLS() {
      var configurator = this.tableStore.configurator;
      var state = configurator.instance().state();
      Columns.saveColumnsToLS(state, configurator.viewSource, configurator.instance(), configurator.getLSName());
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          formID = _this$props.formID,
          parentFormID = _this$props.parentFormID;
      var id = createTableID(formID, parentFormID);
      return React.createElement("div", {
        className: classNames(classes.gridContainer)
      }, React.createElement("div", {
        id: "table-loader-".concat(id)
      }), React.createElement("div", {
        className: classes.fullHeight,
        id: id,
        ref: function ref(r) {
          return _this4.el = r;
        }
      }));
    }
  }]);

  return D5Table;
}(React.Component);

_defineProperty(D5Table, "propTypes", {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
});

export default withStyles(styles, {
  withTheme: true
})(D5Table);